export const useTimeForModel = () => {
  const getTimeForModel = (model, data) => {
    switch (model) {
      case 'test':
      case 'article':
        if (!data[getContentCount(model)]) return;
        return `${data[getContentCount(model)]} ${contentTime(
          data[getContentCount(model)],
          getContentText(model),
        )}`;
      default:
        if (!data[getContentCount(model)]) return;
        return `${format(model, data[getContentCount(model)])}`;
    }
  };
  const format = (model, seconds) => {
    const s = seconds % 60;
    const m = Math.floor((seconds / 60) % 60);
    const h = Math.floor((seconds / 60 / 60) % 60);
    return h && m
      ? `${h} ${contentTime(
          // если есть часы то формат hh:mm
          h,
          getContentText(`${model}_h`),
        )} ${m} ${contentTime(m, getContentText(`${model}_m`))}`
      : h && !m // если есть часы но 0 минут то формат hh
      ? `${h} ${contentTime(
          // если есть часы то формат hh:mm
          h,
          getContentText(`${model}_h`),
        )}`
      : !h && !m // если нет часов нет минут то формат ss
      ? `${s} ${contentTime(s, getContentText(`${model}_s`))}` // если нет минут то ss
      : !s // если нет секунд то mm
      ? `${m} ${contentTime(
          // если нет часов то формат mm:ss
          m,
          getContentText(`${model}_m`),
        )}`
      : `${m} ${contentTime(
          // если нет часов то формат mm:ss
          m,
          getContentText(`${model}_m`),
        )} ${s} ${contentTime(s, getContentText(`${model}_s`))}`;
  };
  const getContentCount = (type) => {
    switch (type) {
      case 'test_q':
        return 'questions';
      case 'test':
      case 'article':
        return 'time';
      default:
        return 'duration';
    }
  };
  const getContentText = (type) => {
    switch (type) {
      case 'test_q':
        return ['вопрос', 'вопроса', 'вопросов'];
      case 'videolecture_h':
      case 'audiolecture_h':
        return ['час', 'часа', 'часов'];
      case 'videolecture_m':
      case 'audiolecture_m':
        return ['минута', 'минуты', 'минут'];
      case 'videolecture_s':
      case 'audiolecture_s':
        return ['секунда', 'секунды', 'секунд'];
      default:
        return ['минута', 'минуты', 'минут'];
    }
  };
  const contentTime = (number, txt, cases = [2, 0, 1, 1, 1, 2]) => {
    return txt[
      number % 100 > 4 && number % 100 < 20
        ? 2
        : cases[number % 10 < 5 ? number % 10 : 5]
    ];
  };

  return {
    getTimeForModel,
    format,
    getContentCount,
    getContentText,
    contentTime,
  };
};
